import { Component, Vue } from 'vue-property-decorator'
import DefaultLayout from '@/components/Layouts/Default'

@Component
export default class SignIn extends Vue {

  signInConfig = {
    usernameAttributes: 'Email or Username'
  }

  private mounted() {
    document.onkeyup = function(evt) {
      
      if (evt.target === null) { return }

      // @ts-ignore
      if (evt.target.type !== 'password') {
        // @ts-ignore
        if (evt.target.value) {
          // @ts-ignore
          evt.target.value = evt.target.value.toLowerCase()
        }
      }
    }

    const dict = {
      'qp': {
        'Incorrect username or password.': 'No user was found with that username and password combination',
        'User does not exist.': 'No user was found with that username and password combination',
        '1 validation error detected: Value at \'username\' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}]+': 'Username cannot contain spaces. Autocomplete may have added a space before the username'
      }
    }

    //@ts-ignore
    this.$Amplify.I18n.putVocabularies(dict)
    //@ts-ignore
    this.$Amplify.I18n.setLanguage('qp')

    //@ts-ignore
    heap.track('game:signin:init')
  }

  private render(h: any) {
    return (
      <DefaultLayout>

          <svg viewBox='0 0 977 977'>
            <use xlinkHref='#qp'></use>
          </svg>

          <amplify-sign-in usernameAttributes={this.signInConfig.usernameAttributes}></amplify-sign-in>
      </DefaultLayout>
    );
  }
}
